import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Column } from '../../../../../core/components/Column';
import { TextComponent } from '../../../../../core/components/TextComponent';
import { Container } from '../../../../../core/components/Container';
import { CustomButton } from '../../../../../core/components/CustomButton';
import coupleLove from '../../../../../core/assets/couple_love.png'; 
import vector2 from '../../../../../core/assets/Vector2.png'; 
import { onLogout } from "../../../../auth/presentation/store/auth/AuthThunk";
import { AppDispatch } from "../../../../../core/store/store";
import { useDispatch } from "react-redux";

export const OnboardingAge = () => { 
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const [isUnderAge, setIsUnderAge] = useState(false);
  const logoutSession = () => {
    dispatch(
      onLogout()
    );
    dispatch({ type: "DESTROY_SESSION" });
    navigate('/auth/login', { replace: true });
  }
  return (
    <div className='relative w-full px-5 md:px-0'>
      <img src={vector2} alt='Background Vector' className='absolute bottom-0 right-0 hidden md:block max-w-72 md:max-w-sm lg:max-w-md' />
      
      <Column crossAxisAlignment='center' className='w-full'>
        <div className='mx-auto w-full max-w-[320px] md:max-w-96' >
          <img src={coupleLove} alt='Couple Love' className='h-auto w-full'/>
        </div>
        <Container className='mx-auto box-border w-full max-w-[320px] bg-white px-0 py-10 mt-3 md:mt-6 md:w-auto md:max-w-none md:px-20'>
          <div className='text-center'>
            <TextComponent variant='h4' className='mb-5'>
              Are you 18 years of age? In order to use this app you must be 18 years old or over.
            </TextComponent>
            {isUnderAge && (
              <TextComponent variant='h4' className='mb-8'>
                Sorry, you must be 18 or over to use Unjabbed.
              </TextComponent>
            )}
            <CustomButton onClick={() => {navigate('/unvaccinated')}} children='I’m 18+' className='mb-5'/>
            <CustomButton
              onClick={() => {
                if (isUnderAge) {
                  logoutSession();
                  return;
                }
                setIsUnderAge(true);
              }}
              children={isUnderAge ? 'Back to sign in' : 'I’m under 18'}
              color='black'
            />
          </div>
        </Container>
      </Column>
    </div>
  );
}
